import axios from 'axios';

export async function downloadLog(date) {
    const response = await axios.get(`/logs/${date}`, { responseType: 'blob' });
    return response.data; // This is the Blob
}
